
import { defineComponent } from 'vue'
import Multiselect from 'vue-multiselect'
import {
  tags,
  target,
  group,
  searchQuery
} from '@/composables/IndexTemplates/useFilterAndSearchData'
import PerPageSelector from '@/components/Shared/PerPageSelector.vue'

export default defineComponent({
  components: {
    Multiselect,
    PerPageSelector
  },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  emits: ['perPageChanged'],
  setup() {
    return {
      tags,
      target,
      group,
      searchQuery
    }
  },
  methods: {
    customTargetLabel(option: string) {
      return this.$t(`index_templates.filter_and_search.target.types.${option}`)
    }
  }
})
